import { useTranslation } from 'react-i18next';
import { prettyDate } from '@/helpers/utils';
import { useWindowSize } from '@/hooks/useWindowSize';
import { FilterViewMobile } from './mobile';
import { FilterViewDesktop } from './desktop';
import s from './index.module.scss';

export const Filters = props => {
  const { params, setParams } = props;
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('reports');

  const onDateChange = range => {
    setParams(prev => ({ ...prev, range }));
  };

  return (
    <div className={s.wrapper}>
      {isMobile ? (
        <FilterViewMobile {...props} onDateChange={onDateChange} />
      ) : (
        <FilterViewDesktop {...props} onDateChange={onDateChange} />
      )}
      <div className={s.footer}>
        <div className="f-small-regular">
          {t('tax_filters.tax_report', {
            from: prettyDate(params.range[0], 'DD MMMM YYYY'),
            to: prettyDate(params.range[1], 'DD MMMM YYYY'),
          })}
        </div>
      </div>
    </div>
  );
};
